import { clsx } from 'clsx';

interface DirectPaymentInfoCardProps {
  chainStoreName: string;
  transactionTypeI18n: string;
  amount: string;
}

export const DirectPaymentInfoCard = ({
  chainStoreName,
  transactionTypeI18n,
  amount,
}: DirectPaymentInfoCardProps) => {
  const list = [
    {
      key: 'store',
      title: '商店',
      value: chainStoreName,
    },
    {
      key: 'item',
      title: '品名',
      value: transactionTypeI18n,
    },
    {
      key: 'amount',
      title: '小計',
      value: `${Math.round(+amount)} 元`,
      isBold: true,
    },
  ];

  return (
    <div
      className={clsx(
        'flex',
        'flex-col',
        'items-stretch',
        'px-6',
        'pt-16',
        'pb-8',
        'rounded-[10px]',
        'shadow-[0_4px_16px_rgba(0,0,0,0.12)]',
        'bg-white',
        'relative',
      )}
    >
      <div
        className={clsx(
          'w-[100px]',
          'h-[100px]',
          'bg-no-repeat',
          'bg-center',
          'bg-contain',
          'border-[white]',
          'border-[4px]',
          'overflow-hidden',
          'rounded-full',
          'absolute',
          'top-0',
          'left-1/2',
          'transform',
          '-translate-x-1/2',
          '-translate-y-1/2',
        )}
        style={{
          backgroundImage: `url("../assets/img-chainstore.svg")`,
        }}
      />
      <h2 className="text-center text-[24px] font-extrabold">確認交易內容</h2>
      <ul className="w-full flex flex-col gap-2 mt-4">
        {list.map(({ key, title, value, isBold }) => (
          <li key={key} className="flex justify-between text-base">
            <span className="text-[#999999]">{title}</span>
            <span className={clsx({ 'font-medium': isBold })}>{value}</span>
          </li>
        ))}
      </ul>
      <hr className="border-[1px] border-dashed w-full my-4" />
      <div className="flex justify-between w-full">
        <span className="text-[#999999]">付款金額</span>
        <span className="font-medium text-[18px] text-[#00D7B2]">{`${Math.round(
          +amount,
        ).toLocaleString()} 元`}</span>
      </div>
    </div>
  );
};
